// extracted by mini-css-extract-plugin
export default {"banner":"CookieBanner_banner__JAEqo","text":"CookieBanner_text__qeJUR","link":"CookieBanner_link__rWSvA","button":"CookieBanner_button__Of0VM"};